import * as React from "react";
import PropTypes from "prop-types";
const SvgNavigationProfileHighlightedMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zm7.857 26.98C21.644 28.565 18.931 29.5 16 29.5s-5.644-.934-7.857-2.52c.138-.776.312-1.546.521-2.307l.245-.887c.463-1.677 1.48-2.908 2.85-3.265 1.094-.285 2.52-.52 4.241-.52s3.147.235 4.242.52c1.368.357 2.386 1.588 2.849 3.265l.245.887c.21.761.383 1.53.521 2.306zM16 17.5A4.75 4.75 0 1116 8a4.75 4.75 0 010 9.5z"
        fill=""
      />
    </svg>
  )
);
SvgNavigationProfileHighlightedMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgNavigationProfileHighlightedMedium;
